<template>
    <div style="padding-bottom: 55px">
        <div v-show="isFirst">
            <div style="margin-top: 20px;">
                <el-row>
                    <el-col :span="6">
                        <el-button type="primary" style="margin-left: 3px;" @click="batchSetTicketHandler(true)">分配</el-button>
                        <el-button type="success" style="margin-left: 3px;" @click="batchUpdateTicketStatus(true,3)">完成</el-button>
                        <el-button type="danger" style="margin-left: 3px;" @click="batchUpdateTicketStatus(true,4)">挂起</el-button>
                    </el-col>
                    <el-col :span="18">
                        <div style="width: 100%;text-align: right;">
                            <el-select v-model="condition.statuses" style="width: 110px;">
                                <el-option label="全部状态" value=""></el-option>
                                <el-option label="待处理" value="1"></el-option>
                                <el-option label="已分配" value="2"></el-option>
                                <el-option label="已解决" value="3"></el-option>
                                <el-option label="已挂起" value="4"></el-option>
                            </el-select>
                            <el-select style="width: 110px;margin-left: 3px;" v-model="queryItem" placeholder="请选择">
                                <el-option label="工单ID" :value="1"></el-option>
                                <el-option label="其他" :value="2"></el-option>
                                <el-option label="创建日期" :value="3"></el-option>
                            </el-select>
                            <el-input type="text" style="width:275px;margin-left: 3px;" v-model="queryValue"
                                      v-if="queryItem!=3" :placeholder="('请输入'+(queryItem==2?'客户姓名，手机号或者设备SN':'工单ID'))"></el-input>
                            <el-date-picker style="width: 275px;margin-left: 3px;" v-if="queryItem==3" v-model="time"
                                            type="daterange" range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="timestamp"></el-date-picker>
                            <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search"
                                       @click="getTableData()">搜索</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 15px;">
                <el-table ref="multipleTable"
                          :data="tableData"
                          style="width: 100%"
                          element-loading-text="数据正在加载中"
                          @selection-change="handleSelectionChange"
                          :header-cell-style="headClass"
                          :row-style="rowClass">
                    <el-table-column type="selection" width="60"></el-table-column>
                    <el-table-column prop="tkid" label="工单ID"></el-table-column>
                    <el-table-column prop="typeCode" label="类别"></el-table-column>
                    <el-table-column prop="status" label="状态" :formatter="statusDescForRow"></el-table-column>
                    <el-table-column prop="sn" label="设备SN"></el-table-column>
                    <el-table-column prop="customerName" label="客户姓名"></el-table-column>
                    <el-table-column prop="customerPhone" label="联系电话"></el-table-column>
                    <el-table-column prop="filler.founderName" label="创建人"></el-table-column>
                    <el-table-column prop="posttime" label="创建日期" :formatter="dateFormat"></el-table-column>
                    <el-table-column prop="filler.handlerName" label="跟进人"></el-table-column>
                    <el-table-column prop="finishtime" label="完成日期" :formatter="dateFormat"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <button @click="showDetail(scope.row)">详情</button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background
                               style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="condition.pageId"
                               :page-sizes="[10, 50, 100, 200]"
                               :page-size="condition.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-show="!isFirst">
            <div style="margin-top: 10px;">
                <el-card class="box-card">
                    <div slot="header">
                        <i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback"></i>
                        <el-steps :active="detail.status" finish-status="success" :align-center="true">
                            <el-step title="待处理"></el-step>
                            <el-step title="已分配"></el-step>
                            <el-step title="已解决"></el-step>
                            <el-step title="已挂起"></el-step>
                        </el-steps>
                    </div>
                    <div>
                        <el-row style="padding-left:100px">
                            <el-col>
                                <el-row>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">工单ID：</el-col>
                                            <el-col :span="19">{{detail.tkid}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">标题：</el-col>
                                            <el-col :span="19">{{detail.title}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">设备SN：</el-col>
                                            <el-col :span="19">{{detail.sn}}</el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">状态：</el-col>
                                            <el-col :span="19">{{statusDesc(detail.status)}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">类别：</el-col>
                                            <el-col :span="19">{{detail.typeCode}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">级别：</el-col>
                                            <el-col :span="19">{{detail.level}}</el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">创建人：</el-col>
                                            <el-col :span="19">{{detail.filler.founderName}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">创建日期：</el-col>
                                            <el-col :span="19">{{detail.posttime?getStandardDate(new Date(detail.posttime)):""}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">跟进人：</el-col>
                                            <el-col :span="19">{{detail.filler.founderName}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">分配日期：</el-col>
                                            <el-col :span="19">{{detail.posttime?getStandardDate(new Date(detail.assigntime)):""}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">完成日期：</el-col>
                                            <el-col :span="19">{{detail.posttime?getStandardDate(new Date(detail.finishtime)):""}}</el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            <el-col :span="5" class="info-name">客户姓名：</el-col>
                                            <el-col :span="19">{{detail.customerName}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                           <el-col :span="5" class="info-name">客户手机：</el-col>
                                            <el-col :span="19">{{detail.customerPhone}}</el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-row class="info-item">
                                            
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-row class="info-item">
                                            <el-col :span="1.8" class="info-name">服务地址：</el-col>
                                            <el-col :span="22">{{detail.province+" "+detail.city+" "+detail.district+" "+detail.address}}</el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-row class="info-item">
                                            <el-col :span="1.8" class="info-name">工单描述：</el-col>
                                            <el-col :span="22">{{detail.description}}</el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="1.8" class="info-name">工单图片：</el-col>
                                    <el-col :span="22">
                                        <el-image
                                                  class="detail-image"
                                                  style="margin-right:10px"
                                                  :src="url"
                                                  :preview-src-list="images"
                                                  v-for="url in images" />
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24" style="text-align: center;">
                                        <el-button type="primary" style="margin-left: 3px;" @click="batchSetTicketHandler(false)">分配</el-button>
                                        <el-button type="success" style="margin-left: 3px;" @click="batchUpdateTicketStatus(false,3)">完成</el-button>
                                        <el-button type="danger" style="margin-left: 3px;" @click="batchUpdateTicketStatus(false,4)">挂起</el-button>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>

            </div>
        </div>
    </div>
</template>

<script>
    import {
        request
    } from '@/utils/request'
    import axios from 'axios'
    import {
        getAddressList
    } from "../../assets/js/area.js"

    export default {
        name: 'ticketMng',
        components: {},
        data() {
            var validPhone = (rule, value, callback) => {
                // var regPos = /^1[3|4|5|7|8][0-9]{9}$/;
                var regPos = /^1[0-9][0-9]{9}$/;
                if (!regPos.test(value)) {
                    callback(new Error('手机号格式有误!'));
                } else {
                    callback();
                }
            }
            var validSelectList = (rule, value, callback) => {
                if (value.length != 3) {
                    callback(new Error('请完整地选择地址!'));
                } else {
                    callback();
                }
            }
            return {
                tableData: [],
                total: 0,
                isFirst: true,
                queryItem: 1,
                queryValue: "",
                condition: {
                    statuses: '',
                    pageId: 1,
                    size: 10
                },
                time: [],
                multipleSelection: [],
                detail: {
                    "filler": {}
                },
                images: []

            }
        },
        watch: {},
        computed: {

        },
        mounted() {
            this.getTableData();
        },
        beforeDestroy() {},
        methods: {
            batchSetTicketHandler(batch) {
                let tkids = "";
                if (batch) {
                    if (this.multipleSelection.length == 0) {
                        this.$message.warning("请选择工单");
                        return;
                    }
                    this.multipleSelection.forEach(element => {
                        tkids = tkids + ',' + element.tkid;
                    });
                    tkids = tkids.substring(1);
                } else {
                    tkids = this.detail.tkid + "";
                }
                this.$prompt('请输入安装师傅手机号', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^1[0-9][0-9]{9}$/,
                    inputErrorMessage: '手机格式不正确'
                }).then(({
                    value
                }) => {
                    request({
                        url: '/maintain/batchSetTicketHandler.do',
                        method: 'get',
                        params: {
                            phone: value,
                            tkids
                        }
                    }).then(res => {
                        if (res.data == 0) {
                            this.$message.success('操作成功');
                        } else {
                            this.$message.error("导入失败：" + res.data);
                        }
                        if (batch) {
                            this.getTableData();
                        } else {
                            this.updateDetail();
                        }
                    });
                }).catch(() => {

                });
            },
            updateDetail() {
                request({
                    url: '/maintain/getTicket.do',
                    method: 'get',
                    params: {
                        tkid:this.detail.tkid
                    }
                }).then(res => {
                    this.detail=res.data
                });
            },
            batchUpdateTicketStatus(batch, status) {
                let tkids = "";
                if (batch) {
                    if (this.multipleSelection.length == 0) {
                        this.$message.warning("请选择工单");
                        return;
                    }
                    this.multipleSelection.forEach(element => {
                        tkids = tkids + ',' + element.tkid;
                    });
                    tkids = tkids.substring(1);
                } else {
                    tkids = this.detail.tkid + "";
                }
                request({
                    url: '/maintain/batchUpdateTicketStatus.do',
                    method: 'get',
                    params: {
                        status,
                        tkids
                    }
                }).then(res => {
                    if (res.data == 0) {
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error("导入失败：" + res.data);
                    }
                    if (batch) {
                        this.getTableData();
                    } else {
                        this.updateDetail();
                    }
                });
            },
            goback() {
                this.isFirst = true
            },
            statusDescForRow(row, column) {
                return this.statusDesc(row.status);
            },
            statusDesc(status) {
                if (status == 1) {
                    return '待处理'
                } else if (status == 2) {
                    return '已分配'
                } else if (status == 3) {
                    return '已解决'
                } else if (status == 4) {
                    return '已挂起'
                } else {
                    return '未知'
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            handleSizeChange(val) {
                this.condition.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.condition.pageId = val;
                this.getTableData();
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            getTableData() {
                var thiz = this;
                let params = {}
                params.statuses = thiz.condition.statuses;
                params.pageId = thiz.condition.pageId;
                params.size = thiz.condition.size
                if (thiz.queryItem == 1 && thiz.queryValue != "") {
                    params.tkid = thiz.queryValue
                } else if (thiz.queryItem == 2 && thiz.queryValue != "") {
                    params.searchx = thiz.queryValue
                } else if (this.queryItem == 3) {
                    if (this.time != null && this.time.length > 0) {
                        params.bDate = this.time[0];
                        params.eDate = this.time[1];
                    }
                }
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/maintain/listTicket.do', {
                    params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            showDetail(detail) {
                this.detail = detail;
                console.log(JSON.stringify(detail))
                this.images = JSON.parse(detail.params).images;
                this.isFirst = false;
                // this.$router.push('/maintainManagement/ticketDetail')
            },

            dateFormat(row, column, cellValue, index) {
                var str = cellValue;
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                return year + "-" + month + "-" + day;
            },
        }
    }
</script>

<style scoped>
    .info-name {
        text-align: right;
        color: rgb(158, 157, 157);
    }

    .info-item {
        padding-bottom: 15px;
    }

    .detail-image {
        width: 120px;
        height: 120px;
    }
</style>